import { Button, Chip, Divider, Typography } from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import { useCallback, useContext } from "react";
import { EditButton, Show, SimpleShowLayout, TextField, TopToolbar, useRedirect } from "react-admin";
import { StatusField } from "../../components/forms/status-field";
import { AppContext } from "../../providers/app-context-provider/app.context";

const FormsRequestShow = (props) => {
    const redirect = useRedirect();
    const appContext = useContext(AppContext);

    const Actions = ({ basePath, data }) => {
        return (
            <TopToolbar>
                <Button onClick={() => redirect(`${basePath}`)} startIcon={<Cancel />} children={'Cancelar'} />
            </TopToolbar>
        )
    };

    const FormAction = (props) => {
        if (props.record.status !== 'opened') {
            return (
                <>
                    <StatusField record={props.record} />
                    {
                        props?.record?.observation && (
                            <Chip size={'small'} label={props.record.observation} />
                        )
                    }

                </>
            )
        }
        const owners = props.record.availability?.owners;
        if (owners && owners.length && !owners.find(w => w.id === appContext.currentUser?.id)) {
            return <Alert severity={'warning'}>Usuário sem permissão de finalizar requisição</Alert>
        }
        return <EditButton {...props} label={'Deferir / Indeferir '} />
    }

    return (
        <Show {...props} hasEdit={false} actions={<Actions />} >
            <SimpleShowLayout>
                <TextField source="user.name" label={'Aluno'} fullWidth />
                <Divider />
                <DisplayFormFields />
                <Divider style={{ margin: '10px 0 10px 0' }} />
                <FormAction />
            </SimpleShowLayout>
        </Show>
    )
}

const DisplayFormFields = (props) => {
    return (
        <div style={{ marginTop: 20 }}>
            <Typography variant={'h5'}>{props.record.availability.form.name}</Typography>
            <Typography variant={'h6'}>{props.record.availability.form.description}</Typography>
            <div style={{ display: 'flex', marginTop: 10, flexDirection: 'column', gap: 20 }}>
                {
                    Object.keys(props.record.fields).map((key, idx) => (
                        <div>
                            <DisplayField
                                label={`${idx + 1} - ${key}`}
                                value={props.record.fields[key]}
                            />
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

const DisplayField = props => {
    const { label, value } = props;
    const renderValue = useCallback(() => {
        switch (typeof value) {
            case "string":
            default:
                return value;
            case 'object':
                if (value?.length) {
                  return  (
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                      {
                        value.map(w => (
                          <a
                            target={'_blank'}
                            rel="noreferrer"
                            href={w.path}
                          >
                            <Button color={'primary'}> - {w.name}</Button>
                          </a>
                        ))
                      }
                    </div>
                  )
                }
        }
    }, [value])

  return (
    <div>
      <Typography variant={'subtitle1'}>{label}</Typography>
            <Typography>
                {renderValue()}
            </Typography>
        </div>
    )
}

export default FormsRequestShow;